interface ValidateIbanReturn {
  valid: boolean;
  messages: [string];
  iban: string;
  bankData: {
    bankCode: string;
    name: string;
    zip?: string;
    city?: string;
    bic?: string;
  };
  checkResults: {
    bankCode: true;
  };
}

export class IbanUtils {
  public static validateIban = async (iban: string): Promise<ValidateIbanReturn> => {
    try {
      const response = await fetch(`https://openiban.com/validate/${iban}?getBIC=true&validateBankCode=true`);
      const data = await response.json();

      return data;
    } catch {
      return { valid: false } as ValidateIbanReturn;
    }
  };

  public static getCountry = (iban: string) => {
    if (iban.length < 2) return undefined;
    return iban.substring(0, 2);
  };
}
